import { render, staticRenderFns } from "./ledgerLogDetail.vue?vue&type=template&id=1f533fb6&scoped=true"
import script from "./ledgerLogDetail.vue?vue&type=script&lang=js"
export * from "./ledgerLogDetail.vue?vue&type=script&lang=js"
import style0 from "./ledgerLogDetail.vue?vue&type=style&index=0&id=1f533fb6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f533fb6",
  null
  
)

export default component.exports